module.exports = __webpack_public_path__ + "img/barbell_thumb.3bb36928.jpg";